import { HANDLE_USER_PRODUCT, RESET } from '../actions';
import moment from "moment";

const initialState = {  
    product: [],
    amcStart: null,
    amcEnd: null,
    search: "",
    device_type: ""
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_USER_PRODUCT:
      return {
        ...state,
        ...action.data
      };
    case RESET:
        return initialState;
    default:
      return state;
  } 
}
